/**
 * Shared sizing/positioning for the menus that hang off the right edge of the
 * app header (language, personal credits, account).
 *
 * Element Plus computes the popper position while the panel is still hidden, so
 * the panel measures 0x0 and gets placed as if it started at the trigger. When
 * it is then shown at its real width it can stick out past the right edge of a
 * narrow viewport. On mobile that overflow widens the layout viewport, which
 * stretches the fixed header and drags the whole right-hand control group off
 * screen. Clamping the popper on the horizontal axis keeps the panel — and with
 * it the header — inside the viewport.
 */
export const HEADER_MENU_POPPER_OPTIONS = {
  modifiers: [
    {
      name: "preventOverflow",
      options: {
        altAxis: true,
        // Without this popper keeps the panel glued to the trigger, which is
        // exactly what we cannot afford once the trigger itself is off screen.
        tether: false,
      },
    },
  ],
};

/**
 * The panel's preferred width, capped so it still fits on small phones.
 */
export const headerMenuWidth = (preferred: number): string => `min(${preferred}px, calc(100vw - 16px))`;
